export const msalConfig = {
    auth: {
        clientId: 'f278013e-e00d-40ae-a503-be90217ae3cf',
        authority: 'https://login.microsoftonline.com/2ed3be0e-193e-4886-aceb-0c1032a74a31',
        postLogoutRedirectUri: window.location.origin,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: ('localStorage'),
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints. // "access_as_user"
export const loginRequest = {
    scopes: ['openid', 'profile', 'offline_access', 'api://f278013e-e00d-40ae-a503-be90217ae3cf/access_as_user']
};

export const loginRequestForMsGraph = {
    scopes: ['User.Read']
};